import { DASHBOARD_ROUTE, LOGIN_ROUTE } from "@/constants/routes";
import { Button } from "@/components/ui/button";
import { Seo } from "@/lib/seo";
import { Link } from "react-router-dom";

export const NotFound = () => (
  <div className="flex min-h-screen flex-col items-center justify-center gap-4 bg-background px-4 text-center">
    <Seo
      title="Page not found · bizy"
      description="The page you were looking for does not exist."
      path="/404"
      noindex
    />
    <p className="text-6xl font-bold tracking-tight">404</p>
    <h1 className="text-lg font-semibold">We could not find that page</h1>
    <p className="max-w-md text-sm text-muted-foreground">
      The link may be outdated, or the workspace you are looking for is not available to your account.
    </p>
    <div className="flex gap-2">
      <Button asChild>
        <Link to={DASHBOARD_ROUTE}>Open dashboard</Link>
      </Button>
      <Button asChild variant="outline">
        <Link to={LOGIN_ROUTE}>Sign in</Link>
      </Button>
    </div>
  </div>
);
